import { jsx } from "react/jsx-runtime";
import { useState, useEffect, createContext } from "react";
import { setServerUrl, createMax, fetchRate } from "../../utils/mortgagehelpers/mortgage-helpers.esm.js";
import { RENT_VS_BUY_DEFAULT_VALUES } from "./RentVsBuyCalculator.constants.esm.js";
const HOUSING_TRENDS_API = "/api/rsps/v1/get-housing-trends-data";
const fetchRentVsBuyData = async (purchasePrice, downPaymentPercent) => {
  var _a, _b;
  const fetched = {};
  try {
    setServerUrl();
    createMax();
    const mortgageRate = await fetchRate({
      homePrice: purchasePrice,
      downPayment: purchasePrice * downPaymentPercent / 100
    });
    if (mortgageRate) {
      fetched.mortgageRate = mortgageRate;
    }
  } catch (error) {
    console.error("RVB: failed to fetch mortgage rate", error);
  }
  try {
    const odpResponse = await fetch(HOUSING_TRENDS_API, {
      signal: AbortSignal.timeout(3e3)
    });
    if (odpResponse.ok) {
      const ODPdata = await odpResponse.json();
      const currentHomePrice = (_a = ODPdata.dataPayload) == null ? void 0 : _a.averageHomePrice;
      const currentRent = (_b = ODPdata.dataPayload) == null ? void 0 : _b.averageRent;
      if (currentHomePrice > 0) {
        fetched.purchasePrice = currentHomePrice;
      }
      if (currentRent > 0) {
        fetched.monthlyRent = currentRent;
      }
    }
  } catch (error) {
    console.error("RVB: failed to fetch housing trends", error);
  }
  return fetched;
};
const DataContext = createContext({
  currentState: RENT_VS_BUY_DEFAULT_VALUES,
  setCurrentState: () => void 0
});
const DataProvider = ({
  children,
  initialPurchasePrice,
  initialDownPaymentPercent,
  initialMonthlyRent,
  initialMortgageRate
}) => {
  const [currentState, setCurrentState] = useState({
    ...RENT_VS_BUY_DEFAULT_VALUES,
    ...initialPurchasePrice !== void 0 && {
      purchasePrice: initialPurchasePrice
    },
    ...initialDownPaymentPercent !== void 0 && {
      downPaymentPercent: initialDownPaymentPercent
    },
    ...initialMonthlyRent !== void 0 && {
      monthlyRent: initialMonthlyRent
    },
    ...initialMortgageRate !== void 0 && {
      mortgageRate: initialMortgageRate
    }
  });
  useEffect(() => {
    const purchasePrice = initialPurchasePrice ?? RENT_VS_BUY_DEFAULT_VALUES.purchasePrice;
    const downPaymentPercent = initialDownPaymentPercent ?? RENT_VS_BUY_DEFAULT_VALUES.downPaymentPercent;
    fetchRentVsBuyData(purchasePrice, downPaymentPercent).then((fetched) => {
      setCurrentState((prev) => ({
        ...prev,
        // Only update from fetch for fields not explicitly set by block attrs
        ...initialMortgageRate === void 0 && fetched.mortgageRate !== void 0 && {
          mortgageRate: fetched.mortgageRate
        },
        ...initialPurchasePrice === void 0 && fetched.purchasePrice !== void 0 && {
          purchasePrice: fetched.purchasePrice
        },
        ...initialMonthlyRent === void 0 && fetched.monthlyRent !== void 0 && {
          monthlyRent: fetched.monthlyRent
        }
      }));
    });
  }, []);
  return /* @__PURE__ */ jsx(DataContext.Provider, { value: {
    currentState,
    setCurrentState
  }, children });
};
export {
  DataContext,
  DataProvider
};
